import { CultureInfo } from '../culture-info.model';
import { CultureInfoSrCyrl } from './sr-Cyrl';

/**
 * @ignore
 */
export const CultureInfoSrCyrlXK: CultureInfo = {
  name: 'sr-Cyrl-XK',
  displayName: 'српски (ћирилица, Косово)',
  iso3LanguageCode: 'srp',
  iso2LanguageCode: 'sr',
  ietfLanguageTag: 'sr-Cyrl-XK',
  parent: CultureInfoSrCyrl
};
